/* eslint-disable no-bitwise */

export enum Brand {
  PokerStars = 0x00000001,
  StarsCasino = 0x00000002,
  BetStars = 0x00000004,
  FullTilt = 0x00000040,
  Unknown = 0x00000080,
  PokerStarsVegas = 0x00000100,
  SkyBet = 0x00000200,
  FoxBet = 0x2000
}

export enum CasinoClientPlatform {
  Windows = 1,
  Macintosh,
  iOS,
  Android,
  Web,
  MobileWeb = 8
}

export enum Site {
  COM = 0x00000001,
  NET = 0x00000002,
  IT = 0x00000010,
  FR = 0x00000020,
  EE = 0x00000040,
  BE = 0x00000200,
  ES = 0x00000400,
  DK = 0x00000800,
  EU = 0x00001000,
  USNJ = 0x00004000,
  UK = 0x00008000,
  BG = 0x00010000,
  DESH = 0x00020000,
  RO = 0x00080000,
  PT = 0x00100000,
  CZ = 0x00200000,
  RUSO = 0x00400000,
  RUSOPM = 0x00800000,
  IN = 0x01000000,
  ASIA = 0x02000000,
  RU = 0x04000000,
  USPA = 0x08000000,
  SE = 0x10000000,
  CH = 0x20000000,
  ARBA = 0x20000001,
  USCO = 0x20000002,
  DE = 0x20000003,
  USMI = 0x20000004,
  NL = 0x20000005,
  CAON = 0x20000006,
  GR = 0x2000002d
}

// TODO - refactor into generated enum
export enum Country {
  Argentina = 'AR',
  Austria = 'AT',
  Canada = 'CA',
  France = 'FR',
  Germany = 'DE',
  Mexico = 'MX',
  Netherlands = 'NL',
  Russia = 'RU',
  Ukraine = 'UA',
  UnitedStates = 'US',
  Ireland = 'IE',
  Slovenia = 'SI'
}

export enum Device {
  Unknown = 0,
  Desktop = 1 << 0, // 1
  Tablet = 1 << 1, // 2
  Phone = 1 << 2, // 4
  GameConsole = 1 << 3, // 8
  SmartTV = 1 << 4, // 16
  Wearable = 1 << 5, // 32
  PDA = 1 << 6, // 64
  Other = 1 << 7 // 128
}

export enum PlatformMask {
  WINDOWS = 0x00000001,
  MACOS = 0x00000002,
  IOS = 0x00000004,
  ANDROID = 0x00000008,
  WEB = 0x00000010,
  WEBMOBILE = 0x00000080,
  LINUX = 0x00000020
}

export enum MoneyOption {
  Real,
  Play
}

export enum Vertical {
  Global,
  Account,
  Casino,
  Template,
  Sports
}

export enum EulaType {
  CombinedEulaPrivacy = 'combinedEulaPrivacy',
  Eula = 'eula',
  GameRulesConditions = 'gameRulesConditions',
  GamingAccAgreement = 'gamingAccAgreement',
  IAmEligibleToPlay = 'iAmEligibleToPlay',
  IndianStatesRestrictions = 'indianStatesRestrictions',
  InformationIsComplete = 'informationIsComplete',
  MarketingMailList = 'marketingMailList',
  PlayerIsNot3Party = 'playerIsNot3Party',
  PlayerIsNotPEP = 'playerIsNotPEP',
  Privacy = 'privacy'
}

export enum PostMessage {
  CLOSE_MINIGAME = 'ps_closeminigame',
  CLOSE_DEPOSIT = 'ps_closedeposit',
  CLOSE_ICE = 'ps_closeice',
  CLOSE_ID_SCAN = 'ps_closeidscan',
  CLOSE_LICENSE_MIGRATION = 'ps_closelicensemigration',
  CLOSE_VIPSTORE = 'ps_closevipstore',
  CLOSE_SRWRDCHESTS = 'ps_srwrdsCloseChests',
  CLOSE_PMCASHIER = 'ps_closepmcashier',
  CLOSE_COMPLETED_RMF = 'ps_closedrmf/complete',
  LICENSE_MIGRATION = 'ps_licensemigration',
  OPEN_ACCOUNT = 'ps_openaccount',
  OPEN_DEPOSIT = 'ps_opendeposit',
  OPEN_MINIGAME = 'ps_openminigame',
  LOGOUT = 'ps_logout',
  AGE_VERIFICATION_COMPLETED = 'ps_ageverificationcompleted',
  ACCOUNT_RMF = 'c2l://form/realmoney',
  OPEN_PAY_WALL = 'ps_openpaywall',
  C2L = 'ps_c2l',
  Twitch = 'twitch',
  NEMID_LOGGEDIN = 'ps_nemid_loggedin',
  DEPOSIT_OFFER_BONUS_CODE = 'ps_depositofferbonuscode'
}

export enum CRMZone {
  MY_NEWS = 'WSLTARGETED',
  DOWNLOAD_BANNER = 'WSLMOBILEAPPDOWNLOAD',
  STARS_REWARDS_OPT_IN = 'SWREWARDSOPTIN',
  STARS_REWARDS_INFO = 'SWREWARDSINFO',
  SWC_WELCOME_BONUS = 'SWCWELCOMEBONUS',
  WSL_WELCOME_OFFER_POPUP = 'WSLWELCOMEOFFERPOPUP1',
  WSL_WELCOME_OFFER_ICON = 'WSLWELCOMEOFFERICON'
}

export enum Header {
  Auth = 'x-stars-authenticated',
  Brand = 'x-stars-brand',
  Cache = 'x-skip-cache',
  Country = 'x-stars-geo-country',
  Currency = 'x-stars-currency',
  Device = 'x-device',
  Embedded = 'x-stars-embedded',
  Forwarded = 'x-forwarded-for',
  Host = 'x-forwarded-host',
  OddsFormat = 'x-stars-odds-format',
  Locale = 'x-stars-locale',
  OS = 'x-os-family',
  PowResult = 'pow-result',
  Protocol = 'x-forwarded-proto',
  Region = 'x-stars-region',
  Render = 'x-stars-render',
  Site = 'x-stars-site',
  State = 'x-stars-geo-state'
}

export enum OS {
  Unknown = 0,
  Windows = 1 << 0, // 1
  Mac = 1 << 1, // 2
  // eslint-disable-next-line @typescript-eslint/naming-convention
  iOS = 1 << 2, // 4
  Android = 1 << 3, // 8
  Linux = 1 << 4, // 16
  WindowsPhone = 1 << 5, // 32
  ChromeOS = 1 << 6, // 64
  FireOS = 1 << 7, // 128
  Tizen = 1 << 8, // 256
  Other = 1 << 9 // 512
}

export enum Size {
  XXSmall = 'xxs',
  XSmall = 'xs',
  Small = 'sm',
  Medium = 'md',
  Large = 'lg',
  XLarge = 'xl',
  XXLarge = 'xxl'
}

export enum Source {
  Direct = 'Direct',
  Affiliate = 'Affiliate',
  Adwords = 'Adwords',
  Display = 'Display',
  SEO = 'SEO'
}

export enum Currency {
  AustralianDollar = 'AUD',
  BritishPound = 'GBP',
  BulgarianLev = 'BGN',
  CanadianDollar = 'CAD',
  ChileanPeso = 'CLP',
  DanishKrone = 'DKK',
  Euro = 'EUR',
  HungarianForint = 'HUF',
  IndianRupee = 'INR',
  JapaneseYen = 'JPY',
  MexicanPeso = 'MXN',
  NorwegianKrone = 'NOK',
  PlayMoney = 'PFF',
  PolishZloty = 'PLN',
  RomanianLeu = 'RON',
  RussianRuble = 'RUB',
  SwedishKrona = 'SEK',
  SwissFranc = 'CHF',
  UkrainianHryvnia = 'UAH',
  USDollar = 'USD',
  BrazilianReal = 'BRL'
}

export enum ResolverTag {
  ATSBaseUrl = 'ats-api',
  ATSBootstrap = 'ats-bootstrap',
  ATSCss = 'ats-css',
  AccountEmailValidationCode = 'account-email-validation-code',
  AccountPIN = 'pokerstars-pin',
  AddressChangeSupport = 'address-change-support',
  CasinoAssetWrapper = 'casino-asset-wrapper',
  CasinoRedemption = 'sr_casino_redemption',
  CasinoSlots = 'casino-slots',
  ChestAssets = 'chest_assets',
  CloseAccount = 'cs-account-closure',
  CommunityForumBaseURL = 'CommunityForumBaseURL',
  ConnexOntario = 'connex_ontario',
  ContactSupport = 'contact-support',
  ContactSupportCashierTroubleDeposit = 'contact-support-cashier-trouble-deposit',
  ContactSupportStella = 'contact_support_stella',
  Cookies = 'cookies',
  CRMStarCode = 'crm_starcode',
  CSPasswordReset = 'cs-password-reset',
  CSResponsibleExclusion = 'cs-responsible-exclusion',
  Davos = 'davos',
  DFAccountResponsibleGaming = 'df_account_responsiblegaming',
  DFSecuritySecurityDocumentRequest = 'df_security_securitydocumentrequest',
  DKRegulatorLogo = 'dk_dga_logo',
  ExchangeMybets = 'exchange-mybets',
  ExchangeHome = 'exchange-home',
  ExchangeWhiteLabel = 'exchange_white_label',
  FailedPow = 'failed-pow',
  FreeSpinBonusTermsBonus = 'freespinbonus_terms_bonus',
  FreeSpinBonusTermsBonusCap = 'freespinbonus_terms_bonus_cap',
  FreeSpinBonusTermsCash = 'freespinbonus_terms_cash',
  FreeSpinBonusTermsCashCap = 'freespinbonus_terms_cash_cap',
  GambanUK = 'gamban_uk',
  GambleAware = 'gamble_aware',
  GameSecurity = 'df_security_gamesecurity',
  GamingAccountAgreement = 'gaming_account_agreement',
  GeoAssist = 'geo-assist',
  HelpCenter = 'help-center',
  HelpCenterAccountValidation = 'help_center_account_validation',
  HelpCenterChatBotScript = 'hc-chat-bot-script',
  HelpCenterChatBotUrl = 'hc-chat-bot-url',
  HelpCenterDepositWithdrawal = 'hc_dep_wd',
  HelpCenterFeedback = 'hc-feedback',
  HelpEmails = 'help_emails',
  HelpFaqGeolocation = 'help_faq_geolocation',
  HelpGamecare = 'help_gamcare',
  HelpResponsibleGaming = 'help_responsiblegaming',
  HelpRGRegulatorSE = 'help_rg_regulator_se',
  HelpRGSE = 'help_rg_se',
  Ice2Home = 'ice-home2',
  IceHome = 'ice-home',
  IdscanServerUrl = 'idscan-server-url',
  IGamingOntario = 'igaming-ontario',
  InstantBonusSplitWagerTermsCash = 'Instantbonus_splitwager_terms_cash',
  InstantBonusSplitwagerTermsCash = 'instantBonus_splitwager_terms_cash',
  InstantBonusSplitWagerTermsCashCap = 'Instantbonus_splitwager_terms_cash_cap',
  InstantBonusSplitwagerTermsCashCap = 'instantbonus_splitwager_terms_cash_cap',
  InstantBonusTermsCash = 'instantbonus_terms_cash',
  InstantBonusTermsCashCap = 'instantbonus_terms_cash_cap',
  Joueurs = 'joueurs',
  LiveChatSupport = 'live-chat-support',
  LostRSAToken = 'lost_rsa_token',
  MCEula = 'mc_eula',
  MCEulaARStates = 'mc_eula_ar_states',
  MCPrivacy = 'mc_privacy',
  NPSSubmission = 'stars_nps_submission',
  NPSDismissal = 'stars_nps_dismissal',
  NwWithdrawRestricted = 'nw-withdraw-restricted',
  PanicButtonHelpArticle = 'de-vegas-panic-button-help-article',
  PaymentInstrumentDocuments = 'payment_instrument_documents',
  PlayerLocationCheck = 'player_location_check',
  PlayerProtectionPage = 'player-protection-page',
  PlayingInsightsMvpSurvey = 'playing_insights_mvp_survey',
  PRMCasinoPromoTerms = 'prm_casino_promo_terms',
  PRMCasinoRacesIngame = 'prm_casino_races_ingame',
  PRMPSCasinoDownload = 'prm_pscasino_download',
  ProcessingExchangeTerms = 'processing-exchange-terms',
  PSDownload = 'ps-download',
  PSMessenger = 'ps-messenger',
  PTBlacklist = 'pt_blacklist',
  RamConfig = 'ram_config_url',
  RamCounselingCenter = 'ram_counseling_center',
  RamGamblingTherapy = 'ram_gambling_therapy',
  RamUtils = 'ram_require_js',
  RealMoneyAgeVerificationFaq = 'realmoney_ageverification_faq',
  RealMoneyEcheckTerms = 'realmoney_echeck_terms',
  RealMoneyPspayAstropayRate = 'realmoney_pspay_astropay_rate',
  RealMoneySecurityFaq = 'realmoney_security_faq',
  ResponsibleGamingLogoBe = 'responsible-gaming-logo-be',
  RGPage = 'mc_responsible',
  RGQuestion = 'rg_question',
  RGRegulatorSE = 'rg_regulator_se',
  SecAccountRestricted = 'sec_account_restricted',
  SecurityAgeVerification = 'security-age-verification',
  SelfExclusionAccountReopen = 'self-exclusion-account-reopen',
  SelfExclusionGamStop = 'self-exclusion-gamstop',
  SelfExclusionInformation = 'self-exclusion-information',
  SelfExclusionMerger = 'self-exclusion-merger',
  SelfExclusionResponsibleGamingFT = 'self-exclusion-rg-page-fulltilt',
  SelfExclusionResponsibleGamingPS = 'self-exclusion-rg-page-ps',
  SportsBookFreeBets = 'sportsbook-freebets',
  SportsBookExchange = 'sportsbook-exchange',
  SportsCashBonusTerms = 'bonuscash-terms',
  SrijRIG = 'srij-rig',
  StarsCrmCdnBaseUrl = 'starscrm_cdn_baseurl',
  StarsRewardsWidgetService = 'starsrewards_widgetservice',
  StarsWeb = 'stars_web',
  StarsWebCasino = 'starsweb_casino',
  StarsWebMinilobby = 'starsweb_minilobby',
  StarsWebPoker = 'starsweb_poker',
  StarsWebSports = 'starsweb_sports',
  SubmitDocuments = 'submit-documents',
  SubmitDocumentsVerifications = 'submit-documents-verifications',
  SwcCallbackRedirect = 'swc_callback_redirect',
  SwcContactSupportRestrictedAccount = 'swc-contact-support-restricted-account',
  SwcSubmitDocumentsVerifications = 'swc-submit-documents-verifications',
  SwcWithdrawalDecline = 'swc-withdrawal-decline',
  TwitchAuthorize = 'twitch_authorize',
  UKGamstopMain = 'uk_gamstop_main',
  UKLicenseAccountNumber = 'uk_license_account_number',
  VerifyMeAML = 'verify-me-aml',
  WebPoker = 'web_poker'
}

export enum FormMethod {
  Post = 'post',
  Get = 'get'
}

export enum TokenType {
  Invalid,
  Cashier,
  Freemium,
  CustomerSupport,
  ICE,
  Casino,
  RAM,
  WebAccountService,
  VIPStore,
  RationalWebServices,
  DFSports,
  PokerDuel,
  FTPMigrate,
  Storm,
  PoolBetting
}

export enum RoutingKey {
  CasinoGameInfo = 'CasinoGameInfo',
  FirstWalletHome = 'FirstWalletHome',
  HelpCenter = 'HelpCenter',
  HelpCenterArticle = 'HelpCenterArticle',
  HelpCenterCategoryArticles = 'HelpCenterCategoryArticles',
  HelpCenterSearchArticles = 'HelpCenterSearchArticles',
  Home = 'Home',
  HomeGamesCashGames = 'HomeGamesCashGames',
  HomeGamesClubs = 'HomeGamesClubs',
  HomeGamesInvite = 'HomeGamesInvite',
  HomeGamesLandingPage = 'HomeGamesLandingPage',
  HomeGamesTournaments = 'HomeGamesTournaments',
  SportsCompetition = 'SportsCompetition',
  SportsCompetitionOutrights = 'SportsCompetitionOutrights',
  SportsCompetitionsResults = 'SportsCompetitionsResults',
  SportsCoupon = 'SportsCoupon',
  SportsCoupons = 'SportsCoupons',
  SportsEvent = 'SportsEvent',
  SportsEventResults = 'SportsEventResults',
  SportsExchange = 'SportsExchange',
  SportsGolfCompetitions = 'SportsGolfCompetitions',
  SportsGolfMatches = 'SportsGolfMatches',
  SportsHiddenPromotion = 'SportsHiddenPromotion',
  SportsHiddenPromotions = 'SportsHiddenPromotions',
  SportsHistoricalBets = 'SportsHistoricalBets',
  SportsHorseRacingNext = 'SportsHorseRacingNext',
  SportsHorseRacingMeetings = 'SportsHorseRacingMeetings',
  SportsHorseRacingRace = 'SportsHorseRacingRace',
  SportsInPlay = 'SportsInPlay',
  SportsInPlaySport = 'SportsInPlaySport',
  SportsMatchFiltering = 'SportsMatchFiltering',
  SportsMyBets = 'SportsMyBets',
  SportsPromotion = 'SportsPromotion',
  SportsPromotions = 'SportsPromotions',
  SportsResults = 'SportsResults',
  SportsSelfExcluded = 'SportsSelfExcluded',
  SportsSelfExcludedHistoricalBets = 'SportsSelfExcludedHistoricalBets',
  SportsSelfExcludedMyBets = 'SportsSelfExcludedMyBets',
  SportsSettings = 'SportsSettings',
  SportsSport = 'SportsSport',
  SportsSportInPlay = 'SportsSportInPlay'
}

export enum TrackingCategory {
  Account = 'Account',
  Auth = 'Auth',
  Casino = 'Casino',
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  CRM = 'CRM',
  Rewards = 'Rewards',
  RMF = 'RMF',
  Signup = 'Signup',
  Sports = 'Sports',
  Stars = 'Stars'
}

export enum ThemeMode {
  Light = 'light',
  Dark = 'dark'
}

export enum UILayout {
  Table = 'table',
  Grid = 'grid'
}

export enum DocumentType {
  Passport,
  DrivingLicense,
  NationalIDCard
}

export enum AMLEventType {
  None = 0,
  WaitDocsGrace = 1,
  WaitDocsFinal = 2,
  AccountSuspended = 3
}

export enum DebugKey {
  Frame = 'stars:frame',
  Request = 'stars:request',
  RequestInfo = 'stars:request:info',
  Socket = 'stars:socket',
  Wizard = 'stars:wizard',
  Embedded = 'stars:embedded',
  GeoComply = 'stars:geoComply',
  Error = 'stars:error',
  RgError = 'rgError:sePT',
  Bridge = 'stars:bridge'
}

export enum FeatureFlag {
  ABTestPlayingInsightsProfitLoss = 'abtest_playing_insights_profitloss',
  AccountCreatedContinue = 'AccountCreatedContinue',
  Add2HomeScreen = 'a2hs',
  AMLLoginMsg = 'aml-login-msg',
  AMLLoginMsgVerified = 'aml-login-msg-verified',
  BankID = 'se-bankid-signup',
  CasinoFavorites = 'CasinoFavorites',
  CasinoFreeSpinsToken = 'CasinoFreeSpinsToken',
  CasinoGameInfo = 'CasinoGameInfo',
  CasinoInstantBonusesToken = 'CasinoInstantBonusesToken',
  CasinoLimits = 'eCasinoLimits',
  CasinoLiveRacesTCReqd = 'CasinoLiveRacesTCReqd',
  CasinoNonAuth = 'eCasinoNonAuth',
  CasinoRewardsStoreToken = 'CasinoRewardsStoreToken',
  CasinoSlotRacesTCReqd = 'CasinoSlotRacesTCReqd',
  CasinoSpinOfDay = 'CasinoSpinOfTheDay',
  Chest = 'chestPageEnabled',
  CrossDomainAlternates = 'CrossDomainAlternates',
  CustomPIN = 'custom-pin',
  DEAllowed = 'DE_Allowed',
  DELossLimit = 'DE_losslimit',
  DEPanic = 'DE_Panic',
  DisableBuenosAiresFeatures = 'DisableBuenosAiresFeatures',
  DisableNewUkAgeVerificationFlow = 'DisableNewUkAgeVerificationFlow',
  DisableRam = 'DisableRam',
  DivertRAMToPoker = 'DivertRAMToPoker',
  DocumentsRequestPrompt = 'document_request_prompt',
  DynamicCmsBanners = 'DynamicCmsBanners',
  EnableATSExchangeBetsLink = 'EnableATSExchangeBetsLink',
  EnableATSMaintenance = 'EnableATSMaintenance',
  EnableExchange = 'EnableExchange',
  EnableOneTrust = 'enableOneTrust',
  EUDESelfExcludeRegulatorAlignment = 'eu-de-self-exclude-regulator-alignment',
  ESportsBookAuth = 'eSportsBookAuth',
  EuDeOasisStreetAddress = 'EUDE_Oasis_Street_Address',
  FixedPrizeDrawNotificationEnabled = 'FixedPrizeDrawNotificationEnabled',
  FooterDateTime = 'footer_date_time',
  ForceDefaultLocale = 'ForceDefaultLocale',
  FreeBets = 'freebets',
  Freemium = 'eFreemium',
  FreemiumMobile = 'eFreemiumMobile',
  FreeSpins = 'eFreeSpinsBonuses',
  HandHistoryRAMMyHandHistoryRequests = 'HandHistory_RAM_MyHandHistoryRequests',
  HideRemoveSlfImpLimit = 'hide_RemoveSlfImpLimit',
  HideRsaTokenMenu = 'hideRsaTokenMenu',
  HideStarsPinMenu = 'hideStarsPinMenu',
  HomeGamesNewTab = 'HomeGamesNewTab',
  HomepageOnlyAlternates = 'HomepageOnlyAlternates',
  Ice2Feature = 'ice2',
  IceFeature = 'eIceFeatureEnabled',
  IceLeaderboard = 'eIceLeaderBoard',
  IDScanSDK = 'IDScan-SDK',
  InstantBonusesVisibility = 'Visibility_MyStars_InstantBonuses',
  ISPBonusCash = 'ISP_BonusCash',
  ISPCashOut = 'ISP_CashOut',
  ISPHistoricalBets = 'ISP_HistoricalBets',
  ISPScoreboards = 'ISP_Scoreboards',
  ISPStatusCheck = 'ISP_StatusCheck',
  JWTEnabled = 'JWTEnabled',
  LiveChatSupport = 'eLiveChatSupport',
  LoginSEDialogue = 'loginSEDialogue',
  LowBalancePrompt = 'wc2-balance-low-prompt',
  MiniGameTickets = 'eMiniGameTickets',
  NewContactSupportForm = 'newCsf',
  NPS = 'SW-SimpleNPS',
  PmcPaywall = 'pmc-paywall',
  PSMessenger = 'PSMessenger',
  PredictorGame = 'predictorGameEnabled',
  PreventIndexingTranslatedPages = 'PreventIndexingTranslatedPages',
  PublicLiveChatSupport = 'ePublicLiveChatSupport',
  PKRGameTiles = 'pkrGameTiles',
  PKRHomeGamesStandingsIteration1 = '2022.Q1.Poker.HomeGames.Standings.WEB-10171',
  PKRHomeGamesStandingsIteration2 = '2022.Q1.Poker.HomeGames.Standings.WEB-10172',
  PKRHomeGamesResults = '2022.Q1.Poker.HomeGames.Results.WEB-10301',
  PKRHomeGamesGameTilesUnsupported = '2022.Q2.Poker.HomeGames.GameTiles.WEB-10835',
  ReleaseBonuses = 'ReleaseBonuses',
  RestrictSeWeeklyLimit = 'restrict-se-weekly-limit',
  RmfEmployerInfo = 'rmf-employer-info',
  SelfExclusionNewDesign = 'SelfExclusionNewDesign',
  SeparatedEulaPrivacyPolicy = 'separated_eula_privacy_policy',
  SessionPopupExtended = 'sessionPopupExtended',
  ShowJackpotWheel = 'Show-Jackpot-Wheel',
  SignUpShowState = 'SignUpShowState',
  SkyBetSports = 'sky-bet-sports',
  SnowplowAnalytics = 'snowplow-analytics',
  SportsBonusCash = 'Visibility_MyStars_BonusCash',
  SportsBookLimits = 'eSportsBookLimits',
  SportsBookNonAuth = 'eSportsBookNonAuth',
  SportsBookOptions = 'eSportsBookOptions',
  SwcAffiliateBonus = 'swc-affiliate-bonus',
  SwcCreditTime = 'swc-credit-time',
  SwcDeposit = 'swc-deposit',
  SwcDepositMethodMinimum = 'swc-deposit-method-minimum',
  SwcDepositReloader = 'swc-deposit-reloader',
  SwcECheckConfirmation = 'swc-eCheck-confirmation',
  SwcEmailVerification = 'swc-email-verification',
  SwcExitFlow = 'swc-exit-flow',
  SwcReloaderBonus = 'swc-reloader-bonus',
  SwcRmfAddressSearch = 'swc-rmf-address-search',
  SwcSignup = 'swc-signup',
  SwcSignupDeposit = 'swc-signup-deposit',
  SwcSignupPhoneColection = 'swc-signup-phone-collection',
  SwcSignupPhoneVerification = 'swc-signup-phone-verification',
  SwcSignupRmf = 'swc-signup-rmf',
  SwcTransactionHistory = 'swc-transaction-history',
  SwcTransactionHistoryFilters = 'swc-transaction-history-filters',
  SwcWelcomeBonusScreen = 'swc-welcomebonus-screen',
  SwcWallet = 'swc-wallet',
  SwcWithdrawal = 'swc-withdrawal',
  SwcXpayLibraryTestStatus = 'swc-xpay-library-test-status',
  TemporaryLoginTimeLimit = 'temporaryLoginTimeLimit',
  TheDeal = 'the-deal',
  TheDealHighRoller = 'the-deal-highroller',
  TwitchConnect = 'TwitchConnect',
  UseRam1 = 'UseRam1',
  VerifyAccount = 'verify-account',
  VerifyAccountAfterRmf = 'verify-account-after-rmf',
  VerifyAccountDrivingLicense = 'verify-account-driving-license',
  VerifyAccountNationalId = 'verify-account-national-id',
  VerifyAccountPassport = 'verify-account-passport',
  VIPStoreMobile = 'eVIPStoreMobile',
  VisibilityCookieBanner = 'visibility_cookie_banner',
  VisibilityOASISExclusionOption = 'visibility_OASIS_exclusion_option',
  VisibilityPermanentSelfExclusionUK = 'visibility_permanent_self-exclusion_uk',
  VisibilityPlayingInsights = 'Visibility_Playing_Insights',
  VisibilityPlayingInsightsLoginPopup = 'Visibility_Playing_Insights_Login_popup',
  VisibilityRestrictWithdrawalCancellation = 'visibility_restrict_withdrawal_cancellation',
  Wc2PlayMoney = 'wc2-playmoney',
  WebMPCNotificationEnabled = 'WebMPCNotificationEnabled',
  WebNotificationEnabled = 'WebNotificationEnabled',
  WrmfAcAutotrigger = 'wrmf-ac-autotrigger'
}

export enum LifetimeLimitAckType {
  Initial = 1,
  Annual
}

export enum SuspendAccountCode {
  ExclusionList = '1',
  Blacklisted = '4',
  Suspended = '24'
}

export enum GADimension {
  AffiliateCode = 'dimension1',
  License = 'dimension3',
  LangId = 'dimension5',
  GClientID = 'dimension11',
  WebClientID = 'dimension12',
  ACID = 'dimension13',
  WebIDHit = 'dimension14',
  TimeStamp = 'dimension15',
  SizmekID = 'dimension16',
  MaxymiserID = 'dimension17',
  SignalID = 'dimension18',
  WebIDSession = 'dimension20',
  PromoIA = 'dimension21',
  MSClickID = 'dimension22',
  MachineID = 'dimension25',
  ClientID = 'dimension26',
  SizmekClickID = 'dimension27',
  BrandCode = 'dimension30',
  ApplicationType = 'dimension32',
  DataSource = 'dimension33',
  ApplicationVersion = 'dimension36',
  StarsCardPhysicalCardHolder = 'dimension46',
  UIElementId = 'dimension47',
  UIElementTypeId = 'dimension48',
  UIElementName = 'dimension49',
  UIElementTitle = 'dimension50',
  UIElementLocation = 'dimension51',
  UIElementPosition = 'dimension52',
  UIElementExtendedAttributes = 'dimension53',
  VisitId = 'dimension55',
  IsRMplayer = 'dimension62',
  IsPMplayer = 'dimension63',
  BrandName = 'dimension64',
  SiteName = 'dimension65',
  HostApplicationType = 'dimension66',
  HostApplicationVersion = 'dimension67',
  FacebookClickId = 'dimension73',
  FacebookBrowserId = 'dimension74',
  MoneyType = 'dimension75',
  PageOriginPath = 'dimension76',
  GameName = 'dimension80',
  GameCode = 'dimension81',
  GameTags = 'dimension82',
  GamePlayMode = 'dimension83',
  GameJackpot = 'dimension84',
  GamesInView = 'dimension85',
  GamesTotal = 'dimension86',
  GameVariantID = 'dimension87',
  TabName = 'dimension90',
  WidgetName = 'dimension91',
  LaunchSource = 'dimension92',
  IsFavourite = 'dimension96',
  ActiveTab = 'dimension97',
  ModalContent = 'dimension98',
  WidgetContents = 'dimension99',
  Profit = 'dimension100',
  CampaignID = 'dimension101',
  InputValue = 'dimension102',
  RadioButtonActive = 'dimension103',
  HSPOrFeatureFlags = 'dimension104',
  PlayerCurrency = 'dimension105',
  Amount = 'dimension106',
  ErrorsTracked = 'dimension107',
  GameTicketNumber = 'dimension108',
  TabPosition = 'dimension109',
  AMSPromoCode = 'dimension114',
  TicketID = 'dimension116',
  DepositStatus = 'dimension118',
  DepositRedirectStatus = 'dimension119',
  DepositGateway = 'dimension120'
}
